import { useQuery } from '@tanstack/react-query';
import { logUnknownErrorResponse } from '@hungryroot/o11y';
import {
  StatusCode,
  getApiV3CustomerNeveredIngredientProducts,
} from '@hungryroot/rest';

/** Same window as periodicities: one fetch until an add or remove invalidates it. */
const timeLimit = 15 * 60 * 1000;

export function getCustomerNeveredIngredientProductsQueryKey() {
  return ['Customers', 'neveredIngredientProducts'] as const;
}

/** Products containing the customer's nevered ingredients. */
export function useCustomerNeveredIngredientProducts(options?: {
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: getCustomerNeveredIngredientProductsQueryKey(),
    queryFn: async () => {
      const resp = await getApiV3CustomerNeveredIngredientProducts();

      if (resp.status !== StatusCode.SuccessOK) {
        logUnknownErrorResponse('Get Customer Nevered Ingredient Products', {
          key: 'useCustomerNeveredIngredientProducts',
          status: resp.status,
          error: JSON.stringify(resp.data),
        });

        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
